import { render, staticRenderFns } from "./ReviewYourAnswersNLPR.vue?vue&type=template&id=3df04102"
import script from "./ReviewYourAnswersNLPR.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersNLPR.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports